<template>
  <div class="card ml-20 mr-20">
    <div class="cfLogs pt-20 pl-20 pr-20">
      <h5 class="text-center fw-500">Cloudflare Request Filtering</h5>
      <div class="row">
        <div class="col-md-12 d-flex justify-content-end">
          <button @click="viewModal({}, 'addCFRequestFiltering')" class="btn btn-primary btn-sm">Add CF Request Filtering</button>
        </div>
      </div>
      <table id="datatable-cflogs" class="table table-bordered">
        <thead>
        <th>Email</th>
        <th class="text-center">Plan</th>
        <th class="text-center">Date</th>
        <th class="text-center">Action</th>
        </thead>
        <tbody>
        <tr v-for="(row, index) of modifiedCFLogs" :key="index">
          <td>{{row.email}}</td>
          <td class="text-center">{{row.plan}}</td>
          <td class="text-center">{{formatDate(row.createdAt)}}</td>
          <td class="text-center">
            <button @click="viewModal(row, 'viewModal')" class="btn btn-sm btn-primary"><i class="fa fa-eye"></i></button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <add-c-f-filtering-modal ref="cfFilteringModal"/>
    <div class="stepModal position-relative">
      <div class="modal fade" id="modal" tabindex="-1" role="dialog" aria-labelledby="modal">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="notesModalHeader">View Details</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body bodyTable">
              <table class="table table-striped table-responsive">
                <thead>
                <th>Domain</th>
                <th class="text-center">Status</th>
                <th class="text-center">Username</th>
                <th class="text-center">API Key</th>
                <th class="text-center">Zone</th>
                <th class="text-center">Action</th>
                </thead>
                <tbody>
                <tr v-for="(row, index) of modifiedDomains" :key="index">
                  <td class="flex-column">
                    <span>{{row.domain}}</span>
                    <span v-if="row.error && !row.error.success" class="text-danger mt-5">Re: <span class="text-dark italic">{{row.error.message}}</span></span>
                  </td>
                  <td class="text-center">
                    <i v-if="row.apiResponse && row.apiResponse.success" class="fa fa-check-circle text-success"></i>
                    <i v-else-if="row.error && !row.error.success" class="fa fa-times-circle text-danger"></i>
                  </td>
                  <td class="text-center"><span class="make-cursor-pointer" data-toggle="tooltip" data-placement="top" data-html="true" :title="row.cloudflare.username" @click="doCopy(row.cloudflare.username)">{{row.cloudflare.username ? `${row.cloudflare.username.substring(0,15)}..` : ''}}</span></td>
                  <td class="text-center"><span class="make-cursor-pointer" data-toggle="tooltip" data-placement="top" data-html="true" :title="row.cloudflare.apiKey" @click="doCopy(row.cloudflare.apiKey)">{{row.cloudflare.apiKey ? `${row.cloudflare.apiKey.substring(0,15)}..` : ''}}</span></td>
                  <td class="text-center"><span class="make-cursor-pointer" data-toggle="tooltip" data-placement="top" data-html="true" :title="row.cloudflare.zone_id" @click="doCopy(row.cloudflare.zone_id)">{{row.cloudflare.zone_id ? `${row.cloudflare.zone_id.substring(0,15)}..` : ''}}</span></td>
                  <td class="text-center">
                    <button data-toggle="tooltip" data-placement="top" data-html="true" @click="retry({index, domain: row.domain})" title="Retry" v-if="row.error && !row.error.success" class="btn btn-sm btn-primary">
                      <i v-if="selectedIndex === index" class="fa fa-spin fa-spinner"></i>
                      <i v-else class="fa fa-repeat"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="modal-footer">
              <button class="btn btn-dark">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import {db} from "@/firebase/init";
import moment from "moment";
import Multiselect from "vue-multiselect";
import AddCFFilteringModal from "@/components/Admin/Tools/addCFFilteringModal.vue";

export default {
  name: 'CloudflareLogs',
  components: {AddCFFilteringModal, Multiselect},
  data() {
    return {
      loading: false,
      cfLog: { domains: []},
      cfLogs: [],
      listener: null,
      selectedIndex: -1
    }
  },
  computed: {
    modifiedCFLogs () {
      return this.cfLogs.sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt)
      });
    },
    modifiedDomains() {
      return this.cfLog.domains
    }
  },
  watch: {
    cfLogs (val) {
      if(val.length) {
        // this.renderDatatable()
      }
    }
  },
  mounted() {
    this.load()
  },
  beforeDestroy() {
    if(this.listener){
      this.listener()
    }
  },
  methods: {
    async retry(row) {
      try {
        this.loading = true;
        this.selectedIndex = row.index
        const ref = await this.$http.post('provider/retry_adding_cf', {
          plan: this.cfLog.plan,
          domain: row.domain,
          custId: this.cfLog.uid,
          cfLogId: this.cfLog.id
        })
        console.log('response from api', ref)
        this.cfLog = this.cfLogs.find(el => el.id === this.cfLog.id)
      } catch (e) {
        console.log('error while retrying', e)
      } finally {
        this.loading = false;
        this.selectedIndex = -1

      }
    },
    renderDatatable() {
      if($.fn.DataTable.isDataTable( '#datatable-cflogs' )) {
        $("#datatable-cflogs").DataTable().destroy();
      }
      $("#datatable-cflogs").DataTable({
        ordering: false,
        retrieve: true,
        language: {
          search: "_INPUT_",
          searchPlaceholder: "Search",
          emptyTable: "No data exists",
          size: '40'
        }
      });
    },
    formatDate(date) {
      return moment(date).format('DD MMM, YYYY hh:mm A')
    },
    viewModal(data, type) {
      data.type = type
      this.onViewModal(data)
    },
    onViewModal(data) {
      console.log('ere', data)
      if(data.type === 'viewModal') {
        this.cfLog = data;
        $("#modal").modal('show');
        $('.modal-backdrop').removeClass("modal-backdrop");
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
      } else if(data.type === 'addCFRequestFiltering') {
        this.$refs.cfFilteringModal.load()
      }
    },
    load () {
      this.loading = false;
      let upQuery = db.collection('cfLogs')
      this.listener = upQuery.onSnapshot(querySnapshot => {
        querySnapshot.docChanges().forEach(change => {
          switch (change.type) {
            case 'added':{
              const test= {id: change.doc.id , ...change.doc.data()}
              this.cfLogs.push(test);
              break;}
            case "modified":
            {
              const data = {id: change.doc.id, ...change.doc.data()}
              let taskToUpdate = this.cfLogs.find((task) => task.id === data.id );
              if (taskToUpdate) {
                const allKeys = Object.keys(data);
                for (const key of allKeys){
                  taskToUpdate[key] = data[key];
                }
              }
            }
              break;
            case "removed":
            {
              const removedData = change.doc.data();
              this.cfLogs = this.cfLogs.filter(test => test.id !== removedData.id);
            }
              break;
          }
        });
      });
      this.loading = true;
    },
  }
}
</script>
<style scoped>

</style>
